/* !
 * publication.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	const yearSelect = () => {
		const latest = document.querySelector('.js-latest').textContent;
		const earliest = document.querySelector('.js-earliest').textContent;
		const yearList = document.querySelector('.js-news-yearList .mod-pulldown-ul');
		const head = document.querySelector('.js-news-yearList summary span');

		let thisYear = (FUNCTIONS.va.isEnglish) ? location.pathname.split('/')[4] : location.pathname.split('/')[3];
		let thisCat = (FUNCTIONS.va.isEnglish) ? location.pathname.split('/')[5] : location.pathname.split('/')[4];

		for (var i = latest; i >= earliest; i--) {
			let item = yearList.appendChild(document.createElement('li')).appendChild(document.createElement('a'));
			item.setAttribute('href', `${(FUNCTIONS.va.isEnglish) ? '/english' : ''}/rd/publication/${i}/${(thisCat) ? thisCat + '/' : ''}`);
			item.textContent = `${i}${(FUNCTIONS.va.isEnglish) ? '' : '年'}`;
		}

		// 現在年を選択状態にする
		if (!location.pathname.endsWith('/rd/publication/') && !location.pathname.endsWith('/rd/publication/index.html')) {
			if (thisYear === 'latest') {
				head.textContent = (FUNCTIONS.va.isEnglish) ? 'Latest' : '最新';
			} else {
				head.textContent = `${thisYear}${(FUNCTIONS.va.isEnglish) ? '' : '年'}`;
			}
		}

		// タブカレント
		document.querySelectorAll('.mod-tabMenu a').forEach(ele => {
			if (location.pathname === ele.getAttribute('href')) {
				ele.classList.add('is-active');
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const publicationFUNCTIONS = () => {
		yearSelect();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { publicationFUNCTIONS(); }) : publicationFUNCTIONS();

})(window.FUNCTIONS);
